<template>
  <div class="gold-view">
    <div class="view-scroller">
      <div class="headers">
        <img src="../assets/手机顶部.png" alt />
      </div>
      <div class="content">
        <!-- 大赛简介 CompIntroduct-->
        <div class="content-CompIntroduct">
          <div class="content-CompIntroduct-title titles">
            <span>大赛简介</span>
          </div>
          <div
            class="boxs content-CompIntroduct-items"
          >截至2021年12月30日，私募证券投资基金规模已达6万亿。为顺应行业蓬勃发展的趋势，在第一届的基础上，我们再次联合兴业银行、证券时报、同花顺、美市科技举办第二届“金长江”实盘交易大赛，旨在打造业内具有影响力的私募基金实盘交易大赛品牌。本次大赛将设立包括资金支持、投研支持和品牌宣传等多项丰厚的奖励，遴选投资能力强、发展稳健的优质私募基金，陪伴其共同成长。</div>
        </div>
        <!-- 大赛进程 CompProcess-->
        <div class="content-CompProcess">
          <div class="content-CompProcess-title titles">
            <span>大赛进程</span>
          </div>
          <div class="boxs content-CompProcess-items">
            <!-- <img src="../assets/编组2.png" alt=""> -->
            <img src="../assets/编组 2.png" alt="暂未加载出来" />
          </div>
        </div>
        <!-- 大赛亮点 CompHighlight-->
        <!-- <div class="content-CompHighlight">
          <div class="content-CompHighlight-title titles">
            <span>大赛亮点</span>
          </div>
          <div class="content-CompHighlight-items">
            <div class="boxs fir">
              <div class="fir1">资金支持</div>
              <div class="fir2">
                <p>参赛私募机构优先获得以下资金支持：</p>
                <p>(1) 优先纳入长江证券自有资金直投备选池。</p>
                <p>(2) 优先纳入长江证券、兴业银行代销白名单。</p>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">服务支持</div>
              <div class="fir2">
                <p>参赛私募机构优先获得长江证券提供的各项服务：</p>
                <p>(1) 长江证券研究所提供的投研服务。</p>
                <p>(2) 长江证券提供的高端交易系统服务 (CQT、金航道极速交易系统等)。</p>
                <p>(3) 长江证券提供的基金托管与运营外包服务</p>
                <p>(4) 长江证券提供的基金绩效评价服务</p>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">宣传支持</div>
              <div class="fir2">
                <p>参赛私募机构优先获得权威媒体的品牌宣传支持</p>
                <p>(1) 证券时报提供的私募专访等品牌宣传支持。</p>
                <p>(2) 同花顺提供的品牌宣传支持。</p>
                <p>(3) 美市科技提供的品牌宣传支持。</p>
              </div>
            </div>
          </div>
        </div>-->
        <!-- 参赛福利 CompWelfare-->
        <div class="content-CompWelfare">
          <div class="content-CompWelfare-title titles">
            <span>参赛福利</span>
          </div>
          <div class="content-CompWelfare-items">
            <div class="boxs fir">
              <div class="fir1">非长江证券提供经纪服务或基金托管外包服务的私募产品</div>
              <div class="fir2">
                <div class="fir3">
                  <div style="width:15px;margin-right:5px">(1)</div>
                  <div style="flex:1">长江证券将为其管理人新发产品提供优惠的托管外包费率。</div>
                </div>
                <div class="fir3">
                  <div style="width:15px;margin-right:5px">(2)</div>
                  <div style="flex:1">其管理人（非美市科技合作客户）可获美市科技易私慕简易版、电子签约、易合规、MAP-投研管理系统3个月使用权。</div>
                </div>
                <div class="fir3">
                  <div style="width:15px;margin-right:5px">(3)</div>
                  <div style="flex:1">兴业银行服务礼包</div>
                </div>
                <div class="fir3">
                  <div style="width:15px;margin-right:5px;text-align:center;">●</div>
                  <div style="flex:1">其管理人高管可获得办理楚天精英卡资格（持楚天精英卡可享商务与社交礼遇、生日礼遇、跨境礼遇、便捷账户礼遇、健康管理、子女教育、保管箱尊享、投融资专项服务权益包）；申请白金信用卡资格及首年免年费优惠，持白金信用卡可享兴业银行提供的多种权益包（包括机场贵宾服务、体检、洁牙、高尔夫、高频公共交通意外险等）；</div>
                </div>
                <div class="fir3">
                  <div style="width:15px;margin-right:5px;text-align:center;">●</div>
                  <div style="flex:1">其管理人高管及员工可获得兴业银行兴闪贷、消费贷、经营贷、住房按揭贷款等产品额度及利率优惠，线上办理信用贷，最高额度20万，年利率4.2%起，具体额度、利率以实际审批为准。</div>
                </div>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">由长江证券提供经纪服务的私募产品</div>
              <div class="fir2">
                <p>(1) 其管理人可获得长江证券CQT交易系统基础服务。</p>
                <p>(2) 其管理人可获长江证券CTC综合金融交易终端VIP版服务（含价值3.68万元的同花顺iFinD金融数据终端一年使用权）。</p>
                <p>(3) 其管理人（非美市科技合作客户）可获美市科技易私慕简易版、电子签约、易合规、MAP-投研管理系统3个月使用权。</p>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">大赛期间新增由长江证券提供基金托管外包服务的私募产品</div>
              <div class="fir2">
                <p>(1) 其管理人可获价值3.68万元的同花顺iFinD金融数据终端一年使用权。</p>
                <p>(2) 其管理人（非美市科技合作客户）可获美市科技易私慕G版、电子签约、易合规系统一年使用权（如长江托管的存续产品参赛，其管理人可获美市科技易私慕简易版、电子签约、易合规、MAP-投研管理系统3个月使用权）。</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 大赛奖励 CompListlight-->
        <div class="content-CompRanking">
          <div class="content-CompRanking-title titles">
            <span>大赛奖励</span>
          </div>
          <div class="content-CompRanking-items">
            <div class="boxs fir">
              <!-- <img src="../assets/ONE.png"> -->
              <div class="fir1">
                <div class="fir1-item1">一</div>
                <div class="fir1-item2">荣誉奖励</div>
              </div>
              <div class="fir2">
                <h4>1、最佳私募管理人奖</h4>
                <p>各组赛事总分排名第一的基金管理人，共评选出6名。</p>
                <h4>2、最佳私募产品奖</h4>
                <p>各组赛事总分前3名，共评选出18名。</p>
                <h4>3、优秀私募产品奖</h4>
                <p>各组赛事总分4到10名，共评选出42名。</p>
                <h4>4、潜力私募产品奖</h4>
                <p>各组赛事总分11到25名，共评选出90名。</p>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">
                <div class="fir1-item1">二</div>
                <div class="fir1-item2">长江证券自有资金投资机会</div>
              </div>
              <div class="fir2">
                <h4>对于本次赛事表现优秀的私募管理人，将有机会获得长江证券自有资金投资机会。</h4>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">
                <div class="fir1-item1">三</div>
                <div class="fir1-item2">长江证券私募产品代销优先支持</div>
              </div>
              <div class="fir2">
                <h4>各组赛事总分排名靠前，且满足长江证券《私募管理人及产品代销合作准入标准》的私募机构，长江证券将给予代销评价加分支持。</h4>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">
                <div class="fir1-item1">四</div>
                <div class="fir1-item2">品牌宣传奖励</div>
              </div>
              <div class="fir2">
                <h4>1、证券时报提供的私募专访等品牌宣传支持。</h4>
                <h4>2、同花顺提供的品牌宣传支持。</h4>
                <h4>3、美市科技提供的品牌宣传支持。</h4>
              </div>
            </div>
            <div class="boxs fir">
              <div class="fir1">
                <div class="fir1-item1">五</div>
                <div class="fir1-item2">其它奖励</div>
              </div>
              <div class="fir2">
                <h4>1、长江证券研究服务礼包</h4>
                <p>长江证券向获得最佳私募产品奖且符合合规管理要求的私募机构提供为期一年，价值20万元的“长江研究”小程序使用权，含长江证券研究报告和部分电话会议等研究服务。</p>
                <h4>2、长江证券托管与外包服务增值礼包</h4>
                <p>长江证券向所有获奖机构提供为期一年价值10万元的托管与运营外包服务礼包。</p>
                <h4>3、同花顺金融数据终端礼包</h4>
                <p>同花顺向所有获奖机构提供为期一年价值3.68万元的同花顺iFinD金融数据终端一年使用权。</p>
                <h4>4、美市科技礼包</h4>
                <p>美市科技向各组赛事总得分前十名产品的管理人（非美市科技合作客户）赠送美市科技服务礼包（礼包二选一）；礼包一：易私慕简易版1年+电子签约1年+易合规系统1年使用权；礼包二：MAP-投研管理系统1年使用权。</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 承办方&主办方简介 -->
        <div class="content-CompOrganize">
          <div class="content-CompOrganize-title titles">
            <span>承办方&主办方简介</span>
          </div>
          <div class="content-CompOrganize-items">
            <mt-navbar v-model="selected">
              <mt-tab-item id="1">主办方</mt-tab-item>
              <mt-tab-item id="2">协办方</mt-tab-item>
            </mt-navbar>

            <mt-tab-container v-model="selected">
              <mt-tab-container-item class="sec" id="1">
                <div class="sec-sec1">
                  <div class="sec-sec1-heads">
                    <div class="sec-sec1-heads-imgs">
                      <img src="../assets/banner-05备份.png" alt />
                    </div>
                  </div>
                  <div class="sec-sec1-bodys">
                    <p>长江证券股份有限公司成立于1991年，于2007年在深圳证券交易所主板上市，股票代码000783，是一家实力雄厚、功能齐全、管理规范、业绩突出的全国性综合型证券公司。目前，长江证券股份有限公司已建成涵盖证券、投资银行、资产管理、基金、期货、私募股权投资、另类投资和海外业务等领域的证券金融控股集团，旗下拥有7家全资和控参股子公司，32家分公司、247家证券营业部。依托齐全的业务资质和领先行业的服务能力，公司可为广大个人、机构投资者、企业及政府客户提供投资银行、证券经纪、资产管理、投资、研究、资本中介、国际业务等全方位综合金融服务。</p>
                  </div>
                </div>

                <div class="sec-sec1">
                  <div class="sec-sec1-heads">
                    <div class="sec-sec1-heads-imgs">
                      <img src="../assets/banner-09备份.png" alt />
                    </div>
                  </div>
                  <div class="sec-sec1-bodys">
                    <p>长江期货股份有限公司是长江证券控股子公司，2017年9月在新三板挂牌上市，证券代码为872186。2018年5月入选新三板创新层。在全国拥有5家分公司、16家营业部，是华中地区资格最全、经营范围最广的期货经营机构。长江期货立足于服务产业、服务地方经济发展，先后被湖北省暨武汉市人民政府授予“支持湖北经济发展突出贡献单位”、“湖北资本市场建设发展先进单位”，并荣获多项行业奖项。长江期货依托长江证券雄厚的资本实力、遍布全国的营业网点、享誉业内的研究力量以及领先的IT技术，立足华中，面向全国，努力打造成为业内一流的金融衍生品和风险管理的服务商与供应商。</p>
                  </div>
                </div>

                <div class="sec-sec1">
                  <div class="sec-sec1-heads">
                    <div class="sec-sec1-heads-imgs">
                      <img src="../assets/banner-03备份.png" alt />
                    </div>
                  </div>
                  <div class="sec-sec1-bodys">
                    <p
                      style="border-bottom:none"
                    >兴业银行股份有限公司（简称兴业银行）1988年诞生于福建省福州市，是中国首批成立的股份制商业银行之一，也是中国首家赤道银行。目前，已形成涵盖银行、信托、金融租赁、基金、期货、资产管理、消费金融、研究咨询、数字金融等多个领域的中国主流商业银行集团，稳居全球银行30强、世界500强。截至2019年末，总资产7万亿元，净利润659亿元，拥有45家一级分行（含香港分行）、2032家分支机构，与全球1400多家银行建立代理行关系。</p>
                  </div>
                </div>
              </mt-tab-container-item>
              <mt-tab-container-item class="sec" id="2">
                <div class="sec-sec1">
                  <div class="sec-sec1-heads">
                    <div class="sec-sec1-heads-imgs">
                      <img src="../assets/banner-06.png" alt />
                    </div>
                  </div>
                  <div class="sec-sec1-bodys">
                    <p>
                      《证券时报》创刊于 1993 年 11 月，
                      是人民日报社主管主办的全国性财经证券类日报，
                      是中国证监会、中国银监会、中国保监会指定的
                      信息披露媒体。证券时报社在全国 30 个中心城
                      市设有记者站，通过近年来的不断探索和发展，
                      证券时报目前已建立起以主报为核心，集报纸、
                      网站、手机App、金融终端以及其他各种媒体传
                      播手段为一体的全媒体互动平台。每年组织十几
                      场高端金融论坛、评选活动，汇聚高端金融人才
                      逾千人。
                    </p>
                  </div>
                </div>

                <div class="sec-sec1">
                  <div class="sec-sec1-heads">
                    <div class="sec-sec1-heads-imgs">
                      <img src="../assets/banner-07.png" alt />
                    </div>
                  </div>
                  <div class="sec-sec1-bodys">
                    <p>
                      同花顺公司成立于2001年，是国内第一家互联网
                      金融信息服务业上市公司。公司在业内拥有完整
                      的产业链，产品及服务覆盖产业链上下游，为国
                      内外的各类机构客户提供软件产品及系统维护服
                      务、金融数据服务、智能推广服务，为个人投资
                      者提供金融资讯以及各种投资理财分析工具。同
                      时，公司积极探索、开发基于人工智能、大数据、
                      云计算、金融工程、人机交互等前沿技术的产品
                      及应用，坚持技术创新，实践“让投资变得更简单
                      ”的理念。
                    </p>
                  </div>
                </div>

                <div class="sec-sec1">
                  <div class="sec-sec1-heads">
                    <div class="sec-sec1-heads-imgs">
                      <img src="../assets/banner-04.png" alt />
                    </div>
                  </div>
                  <div class="sec-sec1-bodys">
                    <p>
                      《券商中国》是证券时报旗下最有影响力的
                      新媒体产品。《券商中国》自 2015 年成立
                      已历经 5年发展，现已成为中国第一影响力
                      财经公众号，目前用户数超过 350 万，是
                      财经公号中的佼佼者。 国内顶尖的采编团队
                      ，一流的专家智库，24 小时*365 天的新闻
                      值守，敏锐的财经热点捕捉能力，都是《券商
                      中国》输出高品质内容的强力保证。
                    </p>
                  </div>
                </div>

                <div class="sec-sec1">
                  <div class="sec-sec1-heads">
                    <div class="sec-sec1-heads-imgs">
                      <img src="../assets/banner-08.png" alt />
                    </div>
                  </div>
                  <div class="sec-sec1-bodys">
                    <p style="border-bottom:none">
                      上海美市科技有限公司成立于2015年，
                      致力以科技赋能私募，旗下有“易私慕”
                      、“每市”两大知名品牌。公司2017年
                      成为中国保险资产管理业协会会员，
                      2020年成为中国证券投资基金业协会
                      金融科技专业委员会会员，截至目前，
                      公司已完成B+轮融资，投资方为国有
                      创投机构国鑫创投。
                    </p>
                  </div>
                </div>
              </mt-tab-container-item>
            </mt-tab-container>
          </div>
        </div>
        <div style="display:flex;justify-content: space-around;">
          <!-- 点击报名 -->
          <div class="canjiabtns" @click="goSignUp">点击报名</div>
          <!-- 点击排名 -->
          <div class="canjiabtns" @click="goRank">点击排名</div>
        </div>
      </div>
      <!-- 长江证券底部 -->
      <div class="cjfooter">
        <div class="fir">
          <img src="../assets/编组.png" alt />
        </div>
        <div class="fir">第二届金长江实盘交易大赛</div>
        <div class="fir">copyright@长江证券版权所有</div>
        <div class="sec">
          <div class="sec-f">联系我们</div>
          <div class="sec-s">
            <p>联系人：薛文琦</p>
            <p>电话：027-65795979</p>
            <p>邮箱：xuewq@cjsc.com.cn</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nativeService from '../services/common/nativeService.js'
export default {
  name: 'index',
  props: {
    msg: String
  },
  data() {
    return {
      selected: '1'
    }
  },

  methods: {
    goSignUp() {
      nativeService.routerRedirect('/signUp', this)
    },
    goEventDescription() {
      nativeService.routerRedirect('/eventDescription', this)
    },
    goLogin() {
      nativeService.routerRedirect('/login', this)
    },
    goRank() {
      nativeService.routerRedirect('/newRanking', this)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'sass/gold/common.scss';
@import 'sass/gold/index.scss';
</style>
